import { ImageAsset } from '../images/image-asset-model';
import { MemberInfo } from './member-info.model';
import { Child } from '../children/child.model';
import { ImageAssetItem } from '../images/image-asset-item.model';

export class Member
{
    Id!: number;
    CheckInCheckOutPinCode?: number;
    Children: Child[] = [];
    FirstName?: string;
    LastName?: string;
    PhoneNumber?: string;
    IsRegistered = false;
    Email?: string;
    UserId?: string;
    Photo?: ImageAsset;
    ProfessionalInfo: any;
    MemberInfo?: MemberInfo;
    MembershipTypeId?: number; // Note: this is in MemberInfo when full details are loaded
    CategoryIds: number[] = [];  // Note: this is listed in CategoryItems in MemberInfo when full details are loaded
    NeedsSmsReplyFromOrg = false;
    NeedsSmsReplyFromOrgInLast24Hours = false;
	ActiveYears: number[] = [];

    constructor(json: any = null)
    {
        if (json)
        {
            // Map the json object to 'this' objects properties.
            Object.assign(this, json);

            // Custom mappings
            if (json.Children) this.Children = json.Children.map((json: any) => new Child(json));
            if (json.Photo) this.Photo = new ImageAsset(json.Photo);
            if (json.MemberInfo) this.MemberInfo = new MemberInfo(json.MemberInfo);
            return;
        }

        this.MemberInfo = new MemberInfo();
    }

    get fullName(): string { return `${this.FirstName || ''} ${this.LastName || ''}`; }

    get hasPhoneNumber(): boolean { return this.PhoneNumber != null && this.PhoneNumber.length > 0}
}
